// extracted by mini-css-extract-plugin
module.exports = {"logoDiv":"HighlightLogo_logoDiv__r6IHG","logoText":"HighlightLogo_logoText__HcNBi","logo":"HighlightLogo_logo__ZYzlr"};